module.exports = __webpack_public_path__ + "Roboto-Bold.ecdd509cadbf1ea78b8d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Bold.eot
// module id = 85
// module chunks = 2